import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Subhead02Text } from '../typography/typography';
import { toIconProp } from '../../services/icon-utils';
import { CardChatStyle } from './card-chat-style';

interface ICardChatWhatsapp {
  title: string;
  onClick: () => void;
}

const CardChatWhatsapp: React.FC<ICardChatWhatsapp> = ({ title, onClick }) => {
  const iconProp = toIconProp('fab:whatsapp');

  return (
    <CardChatStyle onClick={() => onClick()}>
      <div className="card-chat-left">
        <FontAwesomeIcon className="card-chat-left__icon" icon={iconProp!} size="2x" />
        <Subhead02Text weight={600}>{title}</Subhead02Text>
      </div>
      <div className="card-chat-right">
        <ArrowForwardIcon />
      </div>
    </CardChatStyle>
  );
};

export default CardChatWhatsapp;
